import * as React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import H4 from '@base/H4/H4';
import P1 from '@base/P1/P1';
import Button from '@base/Button/Button';
import PlusIcon from '@icon/Planner/PlusIcon';
import { ADD_TO_PLANNER_CLICKED } from '@constants/segment';
import { getAnimationPath } from '@utils/animationHelpers';
import LottieAnimation from '@base/LottieAnimation/LottieAnimation';

const Wrapper = styled.div`
  margin-top: ${Spacings.SPACING_6B};
  background: var(--color-base-1);
  box-shadow: ${boxShadowGenerator()};
  border-radius: ${Spacings.SPACING_2B};
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_12B};
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_4B};
  }
`;

const OuterFlex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${mediaQuery.uptoMobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const AnimationContainer = styled(LottieAnimation)`
  height: 72px;
  width: 72px;
`;

const InnerFlex = styled.div`
  display: flex;
  align-items: center;
  ${mediaQuery.uptoMobile} {
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;
    margin-bottom: ${Spacings.SPACING_4B};
    align-items: flex-start;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-left: ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    width: 217px;
    margin-left: 0;
    margin-right: ${Spacings.SPACING_8B};
  }
`;

const StyledP1 = styled(P1)`
  color: var(--color-text-secondary);
  font-weight: ${Fonts.SEMIBOLD};
  margin-top: ${Spacings.SPACING_1B};
`;

const AddToPlannerButton = styled(Button)`
  width: 184px;
  height: 44px;
  background-color: var(--color-text-primary);
  font-size: ${Fonts.P1};
  color: var(--color-text-tertiary);

  &:hover,
  &:active {
    background-color: var(--color-text-primary);
  }
`;

const StyledH4 = styled(H4)`
  ${mediaQuery.uptoMobile} {
    line-height: ${Spacings.SPACING_6B};
  }
`;

const AddCourseToPlannerCard = ({
  isEnrolled,
  handleCreateCoursePlan,
  isScheduled,
  isCompleted
}) => {
  return (
    isEnrolled &&
    !isScheduled &&
    isCompleted && (
      <Wrapper>
        <OuterFlex>
          <InnerFlex>
            <AnimationContainer
              src={getAnimationPath('addToPlannerCard.json')}
            />
            <TextContainer>
              <StyledH4>Learn everyday from planner</StyledH4>
              <StyledP1>
                Choose a preferred time & watch these classes right from your
                planner
              </StyledP1>
            </TextContainer>
          </InnerFlex>
          <AddToPlannerButton
            label="Add to Planner"
            icon={<PlusIcon size="24px" color="var(--color-text-tertiary)" />}
            onClick={() => handleCreateCoursePlan(ADD_TO_PLANNER_CLICKED)}
          />
        </OuterFlex>
      </Wrapper>
    )
  );
};

export default AddCourseToPlannerCard;

AddCourseToPlannerCard.propTypes = {
  isEnrolled: PropTypes.bool,
  handleCreateCoursePlan: PropTypes.func.isRequired
};

AddCourseToPlannerCard.defaultProps = {
  isEnrolled: false
};
